import { lazyLoad } from 'utils/loadable';
import { SplashScreen } from 'app/components/ui/Splash';

export const ForgotPassword = lazyLoad(
  () => import('./index'),
  module => module.ForgotPassword,
  {
    fallback: <SplashScreen />,
  },
);
